/* Club modal: self-hosted email-OTP login (no Shopify page) + member recognizer
   that sets the private `_club_pass` cart attribute so the discount Function applies.

   The same script drives two containers: the global popup (#ClubSignupModal) and
   the full-page landing template (#ClubSignupPage). In PAGE_MODE the container is
   always visible, so the overlay open/close/scroll-lock bits are skipped — every
   form/view/API handler is identical. Only one of the two exists per page. */
(function () {
  var modal = document.getElementById('ClubSignupModal') || document.getElementById('ClubSignupPage');
  if (!modal) return;

  var PAGE_MODE = modal.id === 'ClubSignupPage';
  var API = modal.getAttribute('data-api-base') || '';
  var views = modal.querySelectorAll('.club-view');
  var registerForm = modal.querySelector('[data-club-form]');
  var loginForm = modal.querySelector('[data-club-login]');
  var codeForm = modal.querySelector('[data-club-code]');
  var lastFocused = null;
  var currentEmail = '';
  var flowOrigin = 'login'; // 'register' | 'login' — drives the welcome message
  var checkPolicyScrollable = function () {}; // measures the policy box once visible

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function api(path, opts) {
    return fetch(API + path, Object.assign({ credentials: 'include' }, opts));
  }
  function setMsg(view, text, type) {
    var el = modal.querySelector('[data-club-message="' + view + '"]');
    if (!el) return;
    el.textContent = text || '';
    el.className = 'club-form__message' + (type ? ' is-' + type : '');
  }
  function showView(name) {
    views.forEach(function (v) { v.hidden = v.getAttribute('data-view') !== name; });
    var f = modal.querySelector('.club-view:not([hidden]) input, .club-view:not([hidden]) select');
    if (f) f.focus();
    if (name === 'register') requestAnimationFrame(checkPolicyScrollable);
  }
  function openModal(view) {
    if (!PAGE_MODE) {
      lastFocused = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    // Logged-in members get the member/logout view instead of the login form.
    if (view !== 'register' && document.body.classList.contains('club-member')) {
      showView('member');
    } else {
      showView(view === 'register' ? 'register' : 'login');
    }
  }
  function closeModal() {
    if (PAGE_MODE) return; // the landing page has nothing to close
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  }

  /* ---------- welcome celebration ---------- */
  var CONFETTI_COLORS = ['#c1272d', '#111111', '#f5c2c1', '#d9d9d9', '#ba1a1a', '#8a8a8a'];

  function launchConfetti() {
    var dialog = modal.querySelector('.club-modal__dialog') || modal.querySelector('.club-page__card');
    if (!dialog) return;
    var wrap = document.createElement('div');
    wrap.className = 'club-confetti';
    for (var i = 0; i < 40; i++) {
      var piece = document.createElement('i');
      piece.style.left = Math.random() * 100 + '%';
      piece.style.background = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
      piece.style.animationDelay = (Math.random() * 1.2).toFixed(2) + 's';
      piece.style.animationDuration = (1.8 + Math.random() * 1.4).toFixed(2) + 's';
      wrap.appendChild(piece);
    }
    dialog.appendChild(wrap);
    setTimeout(function () {
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    }, 4200);
  }

  function showSuccess(name) {
    var title = modal.querySelector('[data-club-success-title]');
    if (title) {
      title.textContent =
        flowOrigin === 'register'
          ? 'ברוכים הבאים למועדון סייבקס!'
          : 'ברוך שובך' + (name ? ', ' + name : '') + '!';
    }
    showView('success');
    launchConfetti();
  }

  /* ---------- member recognizer ----------
     The cookie is the real memory (60d). The cart attribute only lives as long as
     the cart, and is wiped after checkout — so we re-apply it whenever the current
     cart is missing it (new visit, new cart, post-purchase, cart cleared). */
  var clubPass = null; // set only from /api/club-token, for verified members

  function ensureClubPassInCart() {
    if (!clubPass || !window.routes || !window.routes.cart_update_url) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var current = cart && cart.attributes && cart.attributes._club_pass;
        if (current === clubPass) return; // already correct
        return fetch(window.routes.cart_update_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { _club_pass: clubPass } }),
        });
      })
      .catch(function () {});
  }

  function refreshMember() {
    return api('/api/club-token', { method: 'GET' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.member) {
          document.body.classList.add('club-member');
          clubPass = d.pass || null;
          var nameEl = modal.querySelector('[data-club-name]');
          if (nameEl) nameEl.textContent = d.name ? ' ' + d.name : '';
          ensureClubPassInCart();
        } else {
          clubPass = null;
          document.body.classList.remove('club-member');
        }
        return d || { member: false };
      })
      .catch(function () { return { member: false }; });
  }
  refreshMember().then(function (d) {
    // On the landing page (always visible) a recognized member sees the member view;
    // everyone else stays on the default register form set by the markup.
    if (PAGE_MODE && d && d.member) showView('member');
  });

  // Re-assert the attribute after cart changes (add to cart empties/creates carts).
  document.addEventListener('click', function (e) {
    if (e.target.closest('[name="add"], .product-form__submit, [data-club-recheck]')) {
      setTimeout(ensureClubPassInCart, 1200);
    }
  });
  window.addEventListener('pageshow', function () { ensureClubPassInCart(); });

  /* ---------- open / close / switch ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-club-open]');
    if (opener) { e.preventDefault(); openModal(opener.getAttribute('data-club-open')); return; }
    if (e.target.closest('[data-club-close]')) { e.preventDefault(); closeModal(); return; }
    var sw = e.target.closest('[data-club-switch]');
    if (sw && modal.contains(sw)) { e.preventDefault(); showView(sw.getAttribute('data-club-switch')); return; }
    if (e.target.closest('[data-club-done]')) {
      // "לחצו להמשיך" — skip the auto-close wait; reload so club prices refresh.
      e.preventDefault();
      window.location.reload();
      return;
    }
    if (e.target.closest('[data-club-logout]')) {
      e.preventDefault();
      var lo = e.target.closest('[data-club-logout]');
      lo.disabled = true; lo.textContent = 'מתנתק...';
      api('/api/club-logout', { method: 'POST' })
        .catch(function () {})
        .then(function () {
          // clear the cart token too, so the discount stops immediately
          return fetch(window.routes.cart_update_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { _club_pass: '' } }),
          }).catch(function () {});
        })
        .then(function () { window.location.reload(); });
      return;
    }
    if (e.target.closest('[data-club-resend]') && currentEmail) {
      e.preventDefault();
      setMsg('code', 'שולחים קוד חדש...', null);
      api('/api/club-login-start', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: currentEmail }) })
        .then(function () { setMsg('code', 'שלחנו קוד חדש לאימייל.', 'success'); })
        .catch(function () { setMsg('code', 'שגיאה בשליחה. נסו שוב.', 'error'); });
    }
  });
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  /* ---------- LOGIN: email -> send code ---------- */
  if (loginForm) {
    loginForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (loginForm.login_email.value || '').trim();
      if (!EMAIL_RE.test(email)) { loginForm.login_email.classList.add('has-error'); return; }
      currentEmail = email;
      flowOrigin = 'login';
      var btn = loginForm.querySelector('button');
      btn.disabled = true; btn.textContent = 'שולח...';
      api('/api/club-login-start', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: email }) })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (d) {
          btn.disabled = false; btn.textContent = 'שלחו לי קוד';
          // Two cases send the shopper to the register form:
          //  - found === false        → not a customer at all
          //  - needsRegistration      → a customer, but never joined the club (must
          //                             accept the club terms once before logging in)
          if (d && (d.found === false || d.needsRegistration)) {
            setMsg('register', d.message || 'האימייל הזה לא רשום אצלנו. הירשמו למועדון ונתחיל!', 'error');
            showView('register');
            if (registerForm) registerForm.email.value = email;
            return;
          }
          showView('code');
          setMsg('code', 'שלחנו קוד ל-' + email, null);
        })
        .catch(function () {
          btn.disabled = false; btn.textContent = 'שלחו לי קוד';
          setMsg('login', 'אירעה שגיאה. נסו שוב.', 'error');
        });
    });
  }

  /* ---------- CODE: verify -> set session ---------- */
  if (codeForm) {
    codeForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (codeForm.code.value || '').trim();
      if (!/^\d{6}$/.test(code)) { codeForm.code.classList.add('has-error'); return; }
      var btn = codeForm.querySelector('button');
      btn.disabled = true; btn.textContent = 'מאמת...';
      api('/api/club-verify', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: currentEmail, code: code }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          btn.disabled = false; btn.textContent = 'התחברו';
          if (res.ok && res.d && res.d.ok) {
            setMsg('code', '', null);
            refreshMember().then(function (d) {
              showSuccess((d && d.name) || (res.d && res.d.name) || '');
              setTimeout(function () { window.location.reload(); }, 3000);
            });
          } else {
            setMsg('code', (res.d && res.d.message) || 'קוד שגוי', 'error');
          }
        })
        .catch(function (err) {
          btn.disabled = false; btn.textContent = 'התחברו';
          // A thrown fetch here is almost always a CORS/network issue — e.g. testing
          // from localhost, where the .cybexonline.co.il session cookie can't be set.
          var onRealDomain = /(^|\.)cybexonline\.co\.il$/.test(window.location.hostname);
          setMsg(
            'code',
            onRealDomain
              ? 'אירעה שגיאת תקשורת. נסו שוב.'
              : 'ההתחברות עובדת רק באתר עצמו (cybexonline.co.il), לא בסביבת פיתוח מקומית.',
            'error'
          );
        });
    });
  }

  /* ---------- scroll-to-accept policy ----------
     The required consent checkbox stays disabled until the policy has been read to
     the end, so the form can't be submitted without it. */
  if (registerForm) {
    var policyBox = modal.querySelector('[data-club-policy]');
    var policyWrap = policyBox && policyBox.closest('.club-policy');
    var policyHint = modal.querySelector('[data-club-policy-hint]');
    var consentRow = modal.querySelector('[data-club-consent-row]');
    var consentBox = registerForm.querySelector('[name="data_consent"]');
    var policyRead = false;

    function markPolicyRead() {
      if (policyRead) return;
      policyRead = true;
      if (policyWrap) policyWrap.classList.add('is-read');
      if (policyHint) policyHint.textContent = '\u2713 קראתם את התקנון — ניתן לאשר ולהמשיך';
      if (consentRow) consentRow.classList.remove('is-locked');
      if (consentBox) consentBox.disabled = false;
    }

    if (policyBox) {
      policyBox.addEventListener('scroll', function () {
        if (policyBox.scrollTop + policyBox.clientHeight >= policyBox.scrollHeight - 16) markPolicyRead();
      });
      // Measured only while visible — inside a display:none modal every dimension is 0.
      checkPolicyScrollable = function () {
        if (policyRead || !policyBox.clientHeight) return;
        if (policyBox.scrollHeight <= policyBox.clientHeight + 16) markPolicyRead();
      };
    } else {
      markPolicyRead(); // fail open: never block signup if the box is missing
    }
  }

  /* ---------- REGISTER: create customer -> code ---------- */
  function validateRegister() {
    var ok = true;
    registerForm.querySelectorAll('[required]').forEach(function (field) {
      field.classList.remove('has-error');
      if (!field.value.trim()) { field.classList.add('has-error'); ok = false; }
    });
    var email = registerForm.querySelector('[name="email"]');
    if (email.value && !EMAIL_RE.test(email.value)) { email.classList.add('has-error'); ok = false; }
    return ok;
  }
  if (registerForm) {
    registerForm.addEventListener('submit', function (e) {
      e.preventDefault();
      setMsg('register', '', null);
      if (!validateRegister()) { setMsg('register', 'נא למלא את כל שדות החובה המסומנים ב-*', 'error'); return; }
      if (registerForm.data_consent && !registerForm.data_consent.checked) {
        registerForm.data_consent.closest('.club-form__consent').classList.add('has-error');
        setMsg('register', 'יש לאשר את סעיף שמירת הפרטים כדי להמשיך', 'error');
        return;
      }

      var payload = {
        first_name: registerForm.first_name.value.trim(),
        last_name: registerForm.last_name.value.trim(),
        email: registerForm.email.value.trim(),
        phone: registerForm.phone.value.trim(),
        due_date: registerForm.due_date.value || '',
        parent_status: registerForm.parent_status.value || '',
        marketing_consent: registerForm.marketing_consent.checked,
        data_consent: registerForm.data_consent ? registerForm.data_consent.checked : false,
      };
      var btn = registerForm.querySelector('[data-club-submit]');
      btn.disabled = true; btn.textContent = 'רק רגע...';

      fetch(registerForm.getAttribute('action'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          btn.disabled = false; btn.textContent = 'בואו נתחיל!';
          if (res.ok && res.d && res.d.ok) {
            currentEmail = payload.email;
            flowOrigin = res.d.existing ? 'login' : 'register';
            registerForm.reset();
            if (res.d.lookupFailed) {
              // Email exists but we couldn't send a code — send them to login instead.
              showView('login');
              if (loginForm) loginForm.login_email.value = currentEmail;
              setMsg('login', res.d.message || 'כבר רשומים אצלנו — התחברו עם האימייל שלכם.', 'error');
              return;
            }
            showView('code');
            setMsg(
              'code',
              res.d.existing
                ? (res.d.message || 'כבר רשומים אצלנו — שלחנו לך קוד התחברות לאימייל.')
                : 'נרשמת בהצלחה! שלחנו קוד התחברות לאימייל.',
              'success'
            );
          } else {
            var msg = (res.d && (res.d.message || (res.d.errors && res.d.errors[0] && res.d.errors[0].message))) ||
              'אירעה שגיאה. נסו שוב או פנו לשירות הלקוחות.';
            setMsg('register', msg, 'error');
          }
        })
        .catch(function () {
          btn.disabled = false; btn.textContent = 'בואו נתחיל!';
          setMsg('register', 'אירעה שגיאת תקשורת. נסו שוב.', 'error');
        });
    });
  }
})();
